<script lang="ts">
  interface Props {
    presentation: {
      title: string;
      description?: string;
      slug: string;
      pdf_url: string;
      user: {
        display_name: string;
        username: string;
      };
    };
  }

  let { presentation }: Props = $props();
</script>

<svelte:head>
  <title>{presentation.title} | AX Hub</title>
  {#if presentation.description}
    <meta name="description" content={presentation.description} />
  {/if}
</svelte:head>

<div class="min-h-screen bg-gray-900 flex flex-col">
  <!-- Top bar -->
  <header class="bg-gray-800 border-b border-gray-700 px-4 py-3 flex items-center justify-between shrink-0">
    <div class="flex items-center gap-3 min-w-0">
      <a href="/pt" class="text-gray-400 hover:text-white transition-colors shrink-0">
        <span class="sr-only">발표자료 목록으로 돌아가기</span>
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </a>
      <div class="min-w-0">
        <h1 class="text-white text-sm font-medium truncate">{presentation.title}</h1>
        <p class="text-gray-400 text-xs">@{presentation.user.username}</p>
      </div>
    </div>
    <a
      href={presentation.pdf_url}
      download
      class="text-xs text-gray-400 hover:text-white border border-gray-600 px-3 py-1.5 hover:border-gray-400 transition-colors shrink-0"
    >
      다운로드
    </a>
  </header>

  <!-- PDF Viewer -->
  <div class="flex-1">
    <iframe
      src={presentation.pdf_url}
      title={presentation.title}
      class="w-full h-full border-0"
      style="min-height: calc(100vh - 52px);"
    ></iframe>
  </div>
</div>
